import {Injectable} from '@angular/core';
import { first } from 'rxjs/operators';
import { DeviceProductService } from '../../api/device-product/device-produc.service';

@Injectable()
export class SearchFilterService {

  constructor(private deviceProductService: DeviceProductService) {}

  private stripString(string) {
    if (string.replace) {
      return string.replace('\'', '');
    } else {
      return string;
    }
  }

  private buildString(properties, searchStrings, or, opString, opEnd) {
    let result = '';
    if (Array.isArray(searchStrings)) {
      searchStrings.forEach((searchString, key) => {
        if (Array.isArray(properties)) {
          result += properties[key] + opString + this.stripString(searchString) + opEnd;
        } else {
          result += properties + opString + this.stripString(searchString) + opEnd;
        }
        if (key !== (searchStrings.length - 1)) {
          result += or ? ' OR ' : ' AND ';
        }
      });
    } else {
      if (Array.isArray(properties)) {
        result += properties[0] + opString + this.stripString(searchStrings) + opEnd;
      } else {
        result += properties + opString + this.stripString(searchStrings) + opEnd;
      }
    }
    return result;
  }

  eq(properties, searchStrings, or?) {
    return this.buildString(properties, searchStrings, or, ' eq \'', '\'');
  }
  ne(properties, searchStrings, or?) {
    return this.buildString(properties, searchStrings, or, ' ne \'', '\'');
  }
  like(properties, searchStrings, or?) {
    return this.buildString(properties, searchStrings, or, ' like \'%', '%\'');
  }
  nl(properties, searchStrings, or?) {
    return this.buildString(properties, searchStrings, or, ' notlike \'%', '%\'');
  }
  is(properties, searchStrings, or?) {
    return this.buildString(properties, searchStrings, or, ' is ', '');
  }
  isNot(properties, searchStrings, or?) {
    return this.buildString(properties, searchStrings, or, ' isnot ', '');
  }
  in(properties, searchStrings, or?) {
    return this.buildString(properties, searchStrings, or, ' IN \'', '\'');
  }
  ni(properties, searchStrings, or?) {
    return this.buildString(properties, searchStrings, or, ' NI \'', '\'');
  }
  gt(properties, searchStrings, or?) {
    return this.buildString(properties, searchStrings, or, ' gt \'', '\'');
  }
  lt(properties, searchStrings, or?) {
    return this.buildString(properties, searchStrings, or, ' lt \'', '\'');
  }
  hf(properties, searchStrings, or?) {
    return this.buildString(properties, searchStrings, or, ' hf \'', '\'');
  }
  hnf(properties, searchStrings, or?) {
    return this.buildString(properties, searchStrings, or, ' hnf \'', '\'');
  }

  setPredefinedFilter_DeviceProductData(dataSource: any) {
    this.deviceProductService.get().pipe(first()).subscribe(result => {
      result.Results.forEach(model => {
        if (model.Manufacturer !== '' && dataSource.searchConfig.filters.find(item => item.name === 'MANUFACTURER').values.indexOf(model.Manufacturer) < 0) {
          dataSource.searchConfig.filters.find(item => item.name === 'MANUFACTURER').values.push(model.Manufacturer);
        }

        if (model.DeviceCategory !== '' && dataSource.searchConfig.filters.find(item => item.name === 'TYPE').values.indexOf(model.DeviceCategory) < 0) {
          dataSource.searchConfig.filters.find(item => item.name === 'TYPE').values.push(model.DeviceCategory.toString());
        }
      });
    });
  }
}
